/**
 * API客户端主入口
 * 统一的API客户端导出和实例化
 */
import { httpClient } from './core/index.js';
import { AuthClient } from './auth/index.js';
import { SubscriptionClient } from './subscription/index.js';
import { CreditsClient } from './credits/index.js';
import { TranslationClient } from './translation/index.js';
import { CouponsClient } from './coupons/index.js';
import { IntegrationClient } from './integration/index.js';
import { ReferralClient } from './referral/index.js';
import { PdfProcessingClient } from './pdf-processing/index.js';
import { PaymentClient } from './payment/index.js';
import { supabase } from '@readsavor/supabase-client';
/**
 * 统一的API客户端实例
 *
 * 使用方式：
 * ```typescript
 * import { apiClient } from '@readsavor/api-client';
 *
 * // 登录
 * const result = await apiClient.auth.login({ email, password });
 *
 * // 获取当前用户
 * const user = await apiClient.auth.getCurrentUser();
 * ```
 */
export const apiClient = {
    auth: new AuthClient(httpClient, supabase),
    subscription: new SubscriptionClient(httpClient),
    credits: new CreditsClient(httpClient),
    translation: new TranslationClient(httpClient),
    coupons: new CouponsClient(httpClient),
    integration: new IntegrationClient(httpClient),
    referral: new ReferralClient(httpClient),
    pdfProcessing: new PdfProcessingClient(httpClient),
    payment: new PaymentClient(httpClient),
};
// 导出核心类型和工具
export * from './core/index.js';
// We need to explicitly export the class here for other packages to use it for instantiation
export { HttpClient } from './core/index.js';
export * from './auth/index.js';
export * from './subscription/index.js';
export * from './credits/index.js';
export * from './translation/index.js';
export * from './coupons/index.js';
export * from './integration/index.js';
export * from './referral/index.js';
export * from './pdf-processing/index.js';
export * from './payment/index.js';
// 导出HTTP客户端以供高级用法
export { httpClient };
//# sourceMappingURL=index.js.map